import { useCallback, useEffect, useRef, useState } from 'react';
import { getCarriers, getCarrier } from '@/services/carriers.service.js';

// List hook — full carriers table, server-ordered by priority then name.
export function useCarrierList() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const aborted = useRef(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const d = await getCarriers();
      if (!aborted.current) { setRows(Array.isArray(d) ? d : []); setError(null); }
    } catch (err) {
      if (!aborted.current) setError(err);
    } finally {
      if (!aborted.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    aborted.current = false;
    refresh();
    return () => { aborted.current = true; };
  }, [refresh]);

  return { rows, error, loading, refresh };
}

// Single-carrier hook for the detail page.
export function useCarrier(slug) {
  const [row, setRow] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const aborted = useRef(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const d = await getCarrier(slug);
      if (!aborted.current) { setRow(d); setError(null); }
    } catch (err) {
      if (!aborted.current) setError(err);
    } finally {
      if (!aborted.current) setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    aborted.current = false;
    refresh();
    return () => { aborted.current = true; };
  }, [refresh]);

  return { row, error, loading, refresh };
}
